import settings_api from 'src/utils/api_requests/setting';
import { GET_ELLA_ORDER_SETTINGS } from './reduxConstants';

export const initializeSettings = (data: any) => {
	return {
		type: 'INITIALIZE_SETTING',
		data,
	};
};

export const sync_ella_order_settings = (ella_order_settings: Record<string, unknown>) => (dispatch: any) => {
	dispatch(initializeSettings({ ella_settings: ella_order_settings }));
	dispatch({ type: GET_ELLA_ORDER_SETTINGS, payload: ella_order_settings });
};

export const refresh_ella_order_settings = () => async (dispatch: any) => {
	try {
		const response = await settings_api.get_configuration('ella_order_settings');
		if (response?.data) {
			dispatch(sync_ella_order_settings(response.data));
		}
	} catch (error) {
		console.error('Failed to refresh ella_order_settings', error);
	}
};

export const cartContainerConfig = (data: any) => {
	return {
		type: 'CART_CONTAINER_CONFIG',
		data,
	};
};

export const inventoryIconConfig = (data: any) => {
	return {
		type: 'INVENTORY_ICON_CONFIG',
		data,
	};
};

export const cartGroupingConfig = (data: any) => {
	return {
		type: 'CART_GROUPING_CONFIG',
		data,
	};
};

export const update_product_listing_config = (data: any) => {
	return {
		type: 'UPDATE_PRODUCT_LISTING_CONFIG',
		data,
	};
};

export const set_payment_terms = (data: any) => {
	return {
		type: 'SET_PAYMENT_TERMS',
		data,
	};
};
